import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneOurteam, updateOurteam } from 'slice/ourteamSlice';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateOurteam = () => {
    const { id } = useParams(); 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, team } = useSelector((state) => state.ourteam);
    
    const [formData, setFormData] = useState({
        name: '',
        role: '',
        description: '',
        image: null,
        imageUpdate: null
    });

    useEffect(() => {
        dispatch(getOneOurteam(id));   // ✅ fetch single team member
    }, [dispatch, id]);

    useEffect(() => {
        if (team) {
            setFormData({
                name: team.name,
                role: team.role,
                description: team.description,
                image: team.image,
                imageUpdate: null
            });
        }
    }, [team]);

    const handleChange = (e) => {
        const { name, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : e.target.value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        for (const key in formData) {
            if (formData[key] !== null) {
                formDataToSend.append(key, formData[key]);
            }
        }

        dispatch(updateOurteam({ id, data: formDataToSend }))
            .unwrap()
            .then(() => {
                toast('Our team updated successfully!');
                navigate('/ourteam');
            })
            .catch(err => {
                console.error(err);
                toast('Failed to update team member.');
            });
    };

    return (
        <div className='container card my-5'>
            <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='name'>Name</label>
                        <input
                            type='text'
                            id='name'
                            name='name'
                            value={formData.name}
                            className='form-control'
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='role'>Role</label>
                        <input
                            type='text'
                            id='role'
                            name='role'
                            value={formData.role}
                            className='form-control'
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-sm-4 mt-2'>
                        <label htmlFor='description'>Description</label>
                        <input
                            type='text'
                            id='description'
                            name='description'
                            value={formData.description}
                            className='form-control'
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-sm-12 mt-2'>
                        <label htmlFor='imageUpdate'>Image</label>
                        <input
                            type='file'
                            id='imageUpdate'
                            name='imageUpdate'
                            className='form-control'
                            onChange={handleChange}
                        />
                    </div>
                    {formData.image && (
                        <div className='col-sm-4 mt-2'>
                            <img
                                src={`${process.env.REACT_APP_BACKEND}team/${formData.image}`}
                                alt='Team Member'
                                width={100}
                            />
                        </div>
                    )}
                </div>
                <div className='mt-3 text-right'>
                    <button className='btn btn-success' disabled={loading}>
                        Update Our Team
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UpdateOurteam;
